import moment from 'moment';
import { getEnv } from '../utils';

const SALESFORCE_QA_URL = 'https://ischool--qa.sandbox.my.salesforce.com';
const SALESFORCE_PROD_URL = 'https://ischool.lightning.force.com';

const getSalesforceBaseUrl = () => {
  return getEnv() === '' ? SALESFORCE_PROD_URL : SALESFORCE_QA_URL;
}

export const getSalesforceImplementationUrl = (implementationId) => {
  const baseUrl = getSalesforceBaseUrl();
  return `${baseUrl}/lightning/r/Implementation__c/${implementationId}/view`;
}

export const getSalesforceEventUrl = (eventId) => {
  const baseUrl = getSalesforceBaseUrl();
  return `${baseUrl}/lightning/r/Project__c/${eventId}/view`;
}

export const implementationsToCalendarEvents = (implementations = []) => {
  return implementations
    .map((implementation) => {
      const {
        id,
        name,
        accountName,
        startDate: startDateParam,
        endDate: endDateParam
      } = implementation

      const startDate = moment(startDateParam);
      const endDate = moment(endDateParam || startDateParam);

      if (!id || !startDate.isValid() || !endDate.isValid()) {
        return undefined;
      }

      return {
        id,
        title: [name, accountName].filter(Boolean).join(' - '),
        start: startDate.startOf('day').toDate(),
        end: endDate.endOf('day').toDate(),
        allDay: true,
        resource: implementation
      };
    })
    .filter(Boolean);
}

const getEventTrainerNames = (trainers = []) => {
  return [...new Set(
    trainers
      .map((trainer) => trainer.trainerName || trainer.attendeeName || trainer.name)
      .filter(Boolean)
  )];
}

export const normalizeEventCalendarItem = (event = {}) => {
  const trainers = Array.isArray(event.trainers) ? event.trainers : [];
  const eventDetails = trainers[0] || {};

  return {
    ...eventDetails,
    ...event,
    id: event.id || event.eventId || eventDetails.eventId,
    name: event.name || event.eventName || eventDetails.eventName,
    accountId: event.accountId || eventDetails.accountId,
    accountName: event.accountName || eventDetails.accountName,
    startDate: event.startDate || eventDetails.startDate,
    endDate: event.endDate || eventDetails.endDate,
    product: event.product || eventDetails.product,
    implementationManagerName: event.implementationManagerName || eventDetails.implementationManagerName,
    trainers,
    trainerNames: Array.isArray(event.trainerNames) ? event.trainerNames : getEventTrainerNames(trainers)
  };
}

export const eventsToCalendarEvents = (events = []) => {
  return events
    .map((event) => {
      const normalizedEvent = normalizeEventCalendarItem(event);
      const {
        id,
        name,
        accountName,
        startDate,
        endDate
      } = normalizedEvent

      const eventStartDate = moment(startDate);
      const eventEndDate = moment(endDate || startDate);

      if (!id || !eventStartDate.isValid() || !eventEndDate.isValid()) {
        return undefined;
      }

      return {
        id,
        title: [name, accountName].filter(Boolean).join(' - '),
        start: eventStartDate.startOf('day').toDate(),
        end: eventEndDate.endOf('day').toDate(),
        allDay: true,
        resource: normalizedEvent
      };
    })
    .filter(Boolean);
}

export const splitEventsForVisibleMonth = (events = [], date = new Date()) => {
  const monthStart = moment(date).startOf('month');
  const monthEnd = moment(date).endOf('month');

  return events.reduce((result, event) => {
    const eventStart = moment(event.start).startOf('day');
    const eventEnd = moment(event.end).endOf('day');
    const spansVisibleMonth = (
      eventStart.isSameOrBefore(monthStart, 'day') &&
      eventEnd.isSameOrAfter(monthEnd, 'day')
    );

    if (spansVisibleMonth) {
      result.monthSpanningEvents.push(event);
    } else {
      result.calendarEvents.push(event);
    }

    return result;
  }, {
    monthSpanningEvents: [],
    calendarEvents: []
  });
}
